import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { AppData, ToastService } from 'src/app/shared';
import { ADDRESS_BY_CITY } from 'src/app/core/constants/app-constants';
import { GooglePlaceDirective } from 'ngx-google-places-autocomplete';
import { Address } from 'ngx-google-places-autocomplete/objects/address';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import { LocationAccuracy } from '@ionic-native/location-accuracy/ngx';
import { Diagnostic } from "@ionic-native/diagnostic/ngx";
// import { AndroidPermissions } from '@ionic-native/android-permissions/ngx';
import { AddressService } from 'src/app/modules/account/component/add-edit-address/service/address.service';
import { isPlatform } from '@ionic/angular';

@Component({
  selector: 'app-delivery-location-modal',
  templateUrl: './delivery-location-modal.component.html',
  styleUrls: ['./delivery-location-modal.component.scss'],
})
export class DeliveryLocationModalComponent implements OnInit, OnDestroy {

  @ViewChild('placesRef', { static: true }) placesRef: GooglePlaceDirective;
  fullAddress: string;
  lat: number;
  lng: number;
  isLocationSearch = true;
  addressOptionsCity = ADDRESS_BY_CITY;

  addressList = [];
  locality = '';
  city = '';
  state = '';
  country = '';
  pincode = '';
  googleLocation = '';
  GPSRequested = false;
  locationSettingAsked = false;
  statusBarHeight = AppData.statusBarHeight;
  constructor(
    private addressService: AddressService,
    public activeModal: NgbActiveModal,
    private geolocation: Geolocation,
    private locationAccuracy: LocationAccuracy,
    public diagnostic: Diagnostic,
    // private androidPermissions: AndroidPermissions,
  ) {
    this.addressService.init(this.setLocality.bind(this), this.setLatLng.bind(this),
      this.setFullAddress.bind(this), this.setCityStateCountry.bind(this), this.setGoogleLocation.bind(this));

  }

  ngOnInit() {
    if (AppData.isAuthenticated && !AppData.userInfoData.isTemporary) {
      this.getAllAddress();
    }
  }

  setLatLng(lat, lng) {
    this.lat = lat;
    this.lng = lng;
  }
  setLocality(val) {
    this.locality = val;
  }

  setGoogleLocation(val) {
    this.googleLocation = val;
  }

  setCityStateCountry(city, state, country, pinCode) {
    this.city = city;
    this.state = state;
    this.country = country;
    this.pincode = pinCode;
  }

  setFullAddress(val) {
    this.fullAddress = val;
  }

  // get your location
  getAllAddress() {
    this.addressService.getAddressList().then((res) => {
      const responseData = res['body']['data'];
      console.log(responseData);
      this.addressList = responseData;
    });
  }


  //
  async handleAddressChange(address: Address) {
    console.log(event);
    // console.log((JSON.stringify(address)))
    this.fullAddress = address.formatted_address;
    const obj = JSON.stringify(address.geometry.location);
    this.lat = JSON.parse(obj).lat;
    this.lng = JSON.parse(obj).lng;
    console.log(this.lat, this.lng)
    await this.addressService.getCityStateCountry(address.address_components);
    await this.addressService.getLocality(address.address_components);
    AppData.currentAddressSub$.next(await this.createLocationObj());
    this.activeModal.close(await this.createLocationObj());
  }

  onGetLatLong(event) {
    this.lat = event.coords.lat;
    this.lng = event.coords.lng;
    this.getLocBaseOnLatLng(this.lat, this.lng);
  }

  // Google Map Marker Dragging code
  markerDragEnd(event: any) {
    this.lat = event.coords.lat;
    this.lng = event.coords.lng;
    this.getLocBaseOnLatLng(this.lat, this.lng);
  }

  //for get current location
  getCurrentLocation() {
    this.geolocation.getCurrentPosition().then((resp) => {
      this.lat = resp.coords.latitude;
      this.lng = resp.coords.longitude;
      this.getLocBaseOnLatLng(this.lat, this.lng);
    })
      .catch((err) => {
        console.log(err);
        alert('Please enable location services to determine your exact location for delivery.');

        //this.createAlert();
        //this.askToTurnOnGPS();
      })

  }

  // get location based on lat and lng
  getLocBaseOnLatLng(lat, lng) {
    this.addressService.currentLocation(lat, lng).then(async (res) => {
      const responseData = res['body']['results'];
      console.log(responseData);
      await this.setFullAddress(responseData[0].formatted_address);
      await this.addressService.getLocality(responseData[0].address_components);
      await this.addressService.getCityStateCountry(responseData[0].address_components);
      AppData.currentAddressSub$.next(await this.createLocationObj());
      this.activeModal.close(await this.createLocationObj());
    });
  }

  // for create obj for set current location
  createLocationObj() {
    const body = {
      'addressTag': this.locality,
      'fullAddress': this.fullAddress,
      'city': this.city,
      'country': this.country,
      'state': this.state,
      'pincode': this.pincode,
      'locality': this.locality,
      'longLat': {
        'coordinates': [this.lng, this.lat]
      },
      'manualOrGPS': this.GPSRequested ? 'GPS' : 'Manual'
    }
    return body;
  }

  locationAccPermission() {
    this.locationAccuracy.canRequest().then((canRequest: boolean) => {
      if (canRequest) {
      } else {
        // this.androidPermissions.requestPermission(this.androidPermissions.PERMISSION.ACCESS_COARSE_LOCATION)
        //   .then((v) => {
        //     if (v.hasPermission) {
        //       this.enableGPS();
        //     }
        //   }, error => {
        //     console.log(error)
        //   });
      }
    });
  }
  enableGPS() {
    this.locationAccuracy.request(this.locationAccuracy.REQUEST_PRIORITY_HIGH_ACCURACY).then(
      () => {
        this.getCurrentLocation()
      },
      error => console.log(JSON.stringify(error))
    );
  }

  async onGetCurrentLoc() {
    console.log(navigator);
    this.GPSRequested = true;
    if(isPlatform('android')){
      // this.androidPermissions.checkPermission(this.androidPermissions.PERMISSION.ACCESS_COARSE_LOCATION).then(
      //   result => {
      //     if (result.hasPermission) {
      //       this.enableGPS();
      //     } else {
      //       this.locationAccPermission();
      //     }
      //   },
      //   error => {
      //     console.log(error);
      //   });
    }else{
      this.getCurrentLocation();
    }
  }

  async onLocationListItemClick(obj) {
    AppData.currentAddressSub$.next(obj);
    obj['manualOrGPS'] = this.GPSRequested ? 'GPS' : 'Manual'
    this.activeModal.close(obj);
  }

  ngOnDestroy() {
    //this.platform.resume.unsubscribe();
    this.GPSRequested = false;
  }

}
